<template>
  <Root />
</template>

<script setup lang="ts">
import { get } from 'lodash-es'
import { h } from 'vue'

import type { TableColumn } from './VTableColumn.vue'

export interface ColumnProps {
  row: any
  index: number
  colindex: number
  toggleExpand: (row: any) => void
  editing: boolean
  expanded: boolean
}

interface Props {
  column: TableColumn
  props: ColumnProps
}

const props = defineProps<Props>()

const Root = () => {
  const attrs = { 'data-label': props.column.props.label }

  if (!props.column.slots?.default) {
    return h('div', attrs, get(props.props.row, props.column.props.prop))
  }

  return h('div', attrs, props.column.slots.default(props.props))
}
</script>
